<div class="chart">
  <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels"
    [chartType]="lineChartType" [options]="lineChartOptions" [plugins]="lineChartPlugins" [colors]="lineChartColors"
    [legend]="lineChartLegend">
  </canvas>
</div>
